const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio",
          },
          waiting: {
            title: "Esperando",
          },
          closed: {
            title: "Finalizado",
          },
        },
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      distributionRuleModal: {
        title: {
          add: "Nueva regla de distribución",
          edit: "Editar regla de distribución",
        },
        form: {
          whatsapp: "Conexión",
          allConnections: "Todas",
          queue: "Cola",
          allQueues: "Todas",
          strategy: "Estrategia",
          members: "Agentes",
          membersHelper:
            "Sin agentes seleccionados, la regla usa los agentes de la cola (o todos los usuarios comunes en una regla general).",
          noUsers: "No se encontraron agentes",
          keepOwnerOnReopen: "Mantener dueño al reabrir",
          enabled: "Regla habilitada",
        },
        strategies: {
          round_robin: "Round robin",
          least_open: "Menor carga",
          random: "Aleatorio",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Regla de distribución guardada satisfactoriamente.",
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Linhas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          saleAuditDashboard: "Auditoría IA",
          saleAudits: "Auditorías",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          saleAuditOnClose: {
            name: "Auditoría automática al cerrar el ticket",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
        distributionRules: {
          title: "Distribución de leads",
          description:
            "Asigna automáticamente nuevos tickets a un agente, por conexión y/o cola.",
          scope: {
            all: "Global",
          },
          membersCount: "{{count}} agente(s)",
          empty: "Ninguna regla de distribución registrada.",
          deleteSuccess: "Regla de distribución eliminada satisfactoriamente.",
          buttons: {
            add: "Nueva regla",
          },
          confirmationModal: {
            title: "Eliminar regla de distribución",
            message:
              "Los tickets ya asignados no se ven afectados. Los nuevos tickets dentro del alcance de esta regla dejan de distribuirse automáticamente. ¿Desea continuar?",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen:
          "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      saleAudit: {
        stages: {
          abordagem: "Abordaje",
          descoberta: "Descubrimiento",
          oferta: "Oferta",
          objecao: "Objeción",
          fechamento: "Cierre",
          pos_venda: "Posventa",
        },
        temperatures: {
          quente: "Caliente",
          morno: "Tibio",
          frio: "Frío",
        },
        outcomes: {
          ganhou: "Ganó",
          negociando: "Negociando",
          perdeu: "Perdió",
          sem_venda: "Sin venta",
        },
        badges: {
          excelente: "Excelente",
          bom: "Bueno",
          ruim: "Malo",
        },
        verdicts: {
          good: "Bueno",
          warn: "Atención",
          bad: "Malo",
        },
        kinds: {
          good: "Positivo",
          warn: "Atención",
          bad: "Negativo",
          neutral: "Neutral",
        },
        emotions: {
          irritado: "Irritado",
          confuso: "Confundido",
          neutro: "Neutral",
          tranquilo: "Tranquilo",
          satisfeito: "Satisfecho",
        },
        impacts: {
          alto: "Alto",
          medio: "Medio",
          baixo: "Bajo",
        },
        levels: {
          junior: "Júnior",
          pleno: "Intermedio",
          senior: "Sénior",
        },
        vsTeam: {
          acima: "Sobre el equipo",
          na_media: "En la media del equipo",
          abaixo: "Bajo el equipo",
        },
      },
      saleAuditDashboard: {
        title: "Auditoría de Atención (IA)",
        loading: "Cargando…",
        tabs: {
          quality: "Calidad",
          conversations: "Atenciones",
          sales: "Ventas",
        },
        filters: {
          dateFrom: "Desde",
          dateTo: "Hasta",
          connection: "Conexión",
          allConnections: "Todas",
          user: "Agente",
          allUsers: "Todos",
        },
        kpis: {
          audited: "Auditadas",
          conversion: "Conversión",
          wonValue: "Ganado (R$)",
          lostValue: "Perdido (R$)",
          avgScore: "Nota promedio",
          badConversations: "Conversaciones malas",
          agents: "Agentes evaluados",
        },
        quality: {
          bands: {
            excelente: "Excelente",
            bom: "Bueno",
            regular: "Regular",
            ruim: "Malo",
          },
          distribution: {
            title: "Distribución por franja",
            empty: "Ninguna conversación auditada en el período.",
          },
          trend: {
            title: "Evolución de la nota promedio",
            avgScore: "Nota promedio",
            empty: "Sin historial de notas en el período.",
          },
          ranking: {
            title: "Ranking de agentes",
            user: "Agente",
            audited: "Auditadas",
            avgScore: "Nota promedio",
            worstCategory: "Peor categoría",
            empty: "Ningún agente auditado en el período.",
          },
          needsAttention: {
            title: "Necesita atención",
            description: "Las 10 conversaciones con peores notas del período.",
            score: "Nota",
            contact: "Cliente",
            user: "Agente",
            topIssue: "Problema principal",
            empty: "Ninguna conversación crítica en el período.",
          },
        },
        funnel: {
          title: "Embudo de ventas",
        },
        ranking: {
          title: "Ranking comercial",
          user: "Vendedor",
          audited: "Auditadas",
          conversion: "Conversión",
          avgScore: "Nota media",
          empty: "Ningún vendedor auditado en el período.",
        },
        lostReasons: {
          title: "Motivos de pérdida",
          empty: "Ningún motivo de pérdida registrado.",
        },
        hotPending: {
          title: "Leads calientes parados",
          description:
            "Negociaciones calientes sin análisis nuevo en 24 horas.",
          inNegotiation: "en negociación",
          cta: "Ver auditorías",
        },
        training: {
          title: "Dónde entrenar al equipo",
          worst: "Peores categorías",
          rest: "Demás categorías",
          empty: "Sin promedios por categoría en el período.",
        },
      },
      saleAudits: {
        title: "Auditorías de Atención",
        tabs: {
          all: "Todas",
        },
        filters: {
          outcome: "Resultado",
          all: "Todos",
        },
        table: {
          contact: "Cliente",
          user: "Agente",
          score: "Nota",
          stage: "Etapa",
          temperature: "Temperatura",
          potentialValue: "Valor potencial",
          outcome: "Resultado",
          suggestedAction: "Próxima acción",
          firstContact: "Primer contacto",
          lastContact: "Último contacto",
          sortAscending: "Ordenado de forma ascendente",
          sortDescending: "Ordenado de forma descendente",
        },
        groups: {
          label: "Agrupar por",
          none: "Ninguno",
          user: "Agente",
          connection: "Conexión",
          day: "Día",
          noUser: "Sin agente",
          summary: "{{count}} conversación(es) · nota media {{avgScore}}",
          summaryNoScore: "{{count}} conversación(es)",
        },
        buttons: {
          loadMore: "Cargar más",
        },
        empty: "No se encontraron auditorías.",
      },
      saleAuditDrawer: {
        header: "Auditoría IA",
        empty: {
          title: "Este ticket aún no fue analizado.",
          description:
            "Ejecute el análisis para recibir score, señales y la próxima jugada.",
        },
        score: "Score de atención",
        probability: "Probabilidad",
        potentialValue: "Valor potencial",
        confidence: "Confianza",
        model: "Modelo",
        analysisTime: "Análisis",
        analyzedAt: "Analizado el",
        summary: "Resumen ejecutivo",
        suggestedAction: "Próxima acción",
        suggestedMessage: "Jugada sugerida",
        sections: {
          play: "Jugada sugerida",
          categories: "Notas por categoría",
          benchmark: "Comparación con el equipo",
          timeline: "Timeline comentado",
          events: "Eventos importantes",
          emotions: "Evolución emocional",
          positives: "Puntos destacados",
          issues: "Problemas",
          missed: "Oportunidades perdidas",
          coaching: "Coaching",
        },
        evidence: {
          show: "Ver evidencias",
          hide: "Ocultar evidencias",
          msgRef: "msg #",
          empty: "Sin evidencias.",
        },
        benchmark: {
          betterThan: "Mejor que {{pct}}% de las conversaciones",
          sampleSize: "Muestra: {{count}} conversaciones auditadas",
          vsTeamAvg: "{{score}} · promedio del equipo {{teamAvg}}",
        },
        timeline: {
          client: "Cliente",
          seller: "Vendedor",
        },
        coaching: {
          train: "Entrenar",
          level: "Nivel",
          vsTeam: "Vs equipo",
          improveProb: "Prob. de mejora",
        },
        toasts: {
          copied: "Mensaje copiado.",
          copyError: "No fue posible copiar el mensaje.",
        },
        buttons: {
          analyze: "Analizar con IA",
          reanalyze: "Reanalizar",
          copy: "Copiar",
        },
      },
      audioTranscription: {
        label: "transcripción automática",
        seeFull: "Ver transcripción completa",
      },
      saleAuditDetail: {
        finalScore: "Nota final",
        seller: "Agente",
        connection: "Conexión",
        weight: "peso",
        opinion: "Dictamen de la IA",
        conversation: {
          title: "Conversación auditada",
          empty: "Este ticket no tiene mensajes.",
          unmatched: "Comentarios de la IA sin mensaje correspondiente",
          media: "[medio]",
          mediaAudio: "🎵 audio",
          mediaImage: "🖼️ imagen",
          mediaVideo: "🎬 video",
          mediaFile: "📎 archivo",
          mediaLocation: "📍 ubicación",
          mediaContact: "👤 contacto",
          transcriptionLabel: "transcripción automática",
        },
        buttons: {
          print: "Imprimir / PDF",
          openFull: "Abrir auditoría completa",
        },
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_DISTRIBUTION_RULE_SCOPE_ALREADY_EXISTS:
          "Ya existe una regla de distribución para esta conexión/cola.",
        ERR_DISTRIBUTION_RULE_INVALID_STRATEGY:
          "Estrategia de distribución inválida.",
        ERR_NO_SALE_AUDIT_FOUND: "Este ticket aún no fue auditado.",
        ERR_CRM_FUNNEL_NOT_FOUND: "Embudo no encontrado.",
        ERR_CRM_FUNNEL_INVALID_NAME: "Ingrese un nombre válido para el embudo.",
        ERR_CRM_FUNNEL_INVALID_COLOR: "Color de embudo inválido.",
        ERR_CRM_FUNNEL_NAME_ALREADY_EXISTS:
          "Ya existe un embudo con este nombre.",
        ERR_CRM_FUNNEL_INVALID_ORDER: "Orden de embudos inválido.",
        ERR_FUNNEL_DEFAULT_UNDELETABLE:
          "El embudo predeterminado no puede ser eliminado.",
        ERR_FUNNEL_HAS_LEADS:
          "Este embudo aún tiene leads. Muévalos o elimínelos antes de eliminar el embudo.",
        ERR_CRM_NO_FUNNEL: "Ningún embudo registrado.",
        ERR_CRM_STAGE_INVALID_NAME:
          "Ingrese un nombre válido para la etapa (mínimo 2 caracteres).",
        ERR_CRM_STAGE_INVALID_COLOR: "Color de etapa inválido.",
        ERR_CRM_STAGE_NAME_ALREADY_EXISTS:
          "Ya existe una etapa con este nombre en este embudo.",
        ERR_CRM_STAGE_INVALID_KIND: "Tipo de etapa inválido.",
        ERR_CRM_STAGE_INVALID_ORDER: "Orden de etapas inválido.",
        ERR_CRM_STAGE_NOT_IN_FUNNEL:
          "Hay etapas que no pertenecen a este embudo.",
        ERR_CRM_STAGE_NO_FALLBACK:
          "No es posible eliminar la última etapa del embudo.",
        ERR_CRM_AUTOMATION_INVALID_TRIGGER:
          "Disparador de automatización inválido.",
      },
    },
  },
};

export { messages };
